"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _HowToPlay = _interopRequireDefault(require("../howToPlay/HowToPlay"));

var _ContestBannerFixture = _interopRequireDefault(require("./ContestBannerFixture"));

var _ContestBannerPrizepool = _interopRequireDefault(require("./ContestBannerPrizepool"));

var _ContestBannerHeader = _interopRequireDefault(require("./ContestBannerHeader"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 1rem 0 3rem;\n"])));

var StyledCard = (0, _styledComponents.default)(_fiverReactUiComponents.Card)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  padding: 0 0 1.5rem;\n  border-radius: 0;\n"])));

var ContestBanner = function ContestBanner(_ref) {
  var app = _ref.app,
      translations = _ref.translations,
      isHowToPlayAboveBanner = _ref.isHowToPlayAboveBanner,
      activePickem = _ref.activePickem,
      prizepool = _ref.prizepool,
      split = _ref.split,
      onRulesClicked = _ref.onRulesClicked;
  var hasPrizeDraw = process.env.REACT_APP_PRIZE_DRAW === "true";
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    hasPrizeDraw: hasPrizeDraw,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledCard, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ContestBannerHeader.default, {
        translations: translations,
        language: app === null || app === void 0 ? void 0 : app.language,
        activePickem: activePickem
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContestBannerFixture.default, {
        isHowToPlayAboveBanner: isHowToPlayAboveBanner,
        activePickem: activePickem
      }), !isHowToPlayAboveBanner && /*#__PURE__*/(0, _jsxRuntime.jsx)(_HowToPlay.default, {
        onRulesClicked: onRulesClicked,
        activePickem: activePickem,
        prizepool: prizepool,
        split: split
      })]
    })
  });
};

var _default = ContestBanner;
exports.default = _default;